// Shared utilities for Admin page tabs
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('/api/')) {
    return `${BACKEND_URL}${url}`;
  }
  if (url.includes('/api/files/')) {
    const path = url.substring(url.indexOf('/api/files/'));
    return `${BACKEND_URL}${path}`;
  }
  return url;
};

export const whatsappTemplates = {
  escalado: (name, date, time) => `Olá ${name}! ⚽ Você foi escalado para a partida de domingo dia ${date} às ${time}. Confirma presença?`,
  pagamento: (name, amount, date) => `Olá ${name}! 💰 Falta o pagamento de ${amount}€ da partida do dia ${date}. Podes transferir?`,
  convite: (name, date, time, location) => `Olá ${name}! ⚽ Vai querer participar da partida dia ${date} às ${time} em ${location}?`,
  titular: (name) => `Olá ${name}! ⭐ Vai querer permanecer como titular (mensalista) no próximo mês?`,
  senha: (name, password) => `Olá ${name}! 🔐 A sua senha de votação é: ${password}`,
  votacao: (name) => `Olá ${name}! 🗳️ A votação do Domingão já está aberta! Entre no site e vote nos seus colegas: https://times-sorteio.preview.emergentagent.com`,
};

export const openWhatsApp = (phone, message) => {
  if (!phone) {
    alert('Este jogador não tem telefone cadastrado. Adicione o número primeiro.');
    return;
  }
  let cleanPhone = phone.replace(/\D/g, '');
  if (!cleanPhone.startsWith('351') && cleanPhone.length <= 9) {
    cleanPhone = '351' + cleanPhone;
  }
  const encodedMessage = encodeURIComponent(message);
  window.open(`https://wa.me/${cleanPhone}?text=${encodedMessage}`, '_blank');
};
